function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linearGradient1760",
  x1: 79.375,
  x2: 156.1,
  y1: 224.9,
  y2: 343.96,
  gradientTransform: "matrix(1.196 0 0 1.196 -2.0578 -57.567)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008582",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#00b3c5",
  stopOpacity: 0.60392,
  offset: 1
})), React.createElement("linearGradient", {
  id: "linearGradient1780",
  x1: 79.375,
  x2: 0.000002,
  y1: 224.9,
  y2: 304.27,
  gradientTransform: "matrix(-1.202 0 0 -1.202 187.88 482.13)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#007e7b",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#00b3c5",
  stopOpacity: 0.60392,
  offset: 1
})), React.createElement("clipPath", {
  id: "clipPath2121"
}, React.createElement("path", {
  d: "m58.917 171.98h67.375a6 6 45 0 1 6 6v67.375a6 6 135 0 1-6 6h-67.375a6 6 45 0 1-6-6v-67.375a6 6 135 0 1 6-6z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), React.createElement("path", {
  d: "m79.375 152.75v-1.2292a6 6 45 0 0-6-6h-40.917a6 6 135 0 0-6 6v40.917a6 6 45 0 0 6 6h1.2292a6 6 135 0 0 6-6v-27.687a6 6 135 0 1 6-6h27.687a6 6 135 0 0 6-6z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), React.createElement("path", {
  d: "m105.83 152.75v-1.2292a6 6 135 0 1 6-6h40.917a6 6 45 0 1 6 6v40.917a6 6 135 0 1-6 6h-1.2292a6 6 45 0 1-6-6v-27.687a6 6 45 0 0-6-6h-27.688a6 6 45 0 1-6-6z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), React.createElement("path", {
  d: "m79.375 270.58v1.2292a6 6 135 0 1-6 6h-40.917a6 6 45 0 1-6-6v-40.917a6 6 135 0 1 6-6h1.2292a6 6 45 0 1 6 6v27.687a6 6 45 0 0 6 6h27.688a6 6 45 0 1 6 6z",
  stroke: "#000",
  strokeWidth: ".26458px"
}), React.createElement("path", {
  d: "m105.83 270.58v1.2292a6 6 45 0 0 6 6h40.917a6 6 135 0 0 6-6v-40.917a6 6 45 0 0-6-6h-1.2292a6 6 135 0 0-6 6v27.687a6 6 135 0 1-6 6h-27.688a6 6 135 0 0-6 6z",
  stroke: "#000",
  strokeWidth: ".26458px"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-26.458 -145.52)"
}, React.createElement("g", {
  clipPath: "url(#clipPath2121)"
}, React.createElement("g", null, React.createElement("path", {
  d: "m13.764 132.29 158.22 158.22h-158.22z",
  fill: "url(#linearGradient1760)"
}), React.createElement("path", {
  d: "m171.98 291.31-159.02-159.02h159.02z",
  fill: "url(#linearGradient1780)"
}))));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m259.5 69.113v32.078q-5.723 4.8168-12.762 7.3959a41.891 41.486 0 0 1-14.65 2.5779 41.451 41.05 0 0 1-11.246-1.5019q-5.4077-1.5019-10.1-4.2505a43.774 43.351 0 0 1-8.5839-6.5741 41.337 40.937 0 0 1-6.6383-8.5008 43.168 42.75 0 0 1-4.2638-10.06 41.761 41.358 0 0 1-1.5166-11.165q0-5.7814 1.5166-11.108a43.426 43.006 0 0 1 4.2638-10.004 41.337 40.937 0 0 1 6.6383-8.5009 42.916 42.501 0 0 1 8.5839-6.5451 42.746 42.333 0 0 1 10.1-4.2226 41.451 41.05 0 0 1 11.246-1.5019 41.891 41.486 0 0 1 14.65 2.579q7.0392 2.5779 12.762 7.3959l-8.585 14.169a27.545 27.278 0 0 0-8.5839-5.8661 25.102 24.86 0 0 0-10.243-2.1252 24.977 24.735 0 0 0-10.1 2.0405 26.899 26.639 0 0 0-8.2698 5.5249 26.299 26.045 0 0 0-5.6081 8.162 24.977 24.735 0 0 0-2.0604 10.003 25.32 25.075 0 0 0 2.0604 10.088 26.554 26.298 0 0 0 5.6081 8.2177 26.648 26.391 0 0 0 8.2698 5.555 24.977 24.735 0 0 0 10.1 2.0394 24.231 23.997 0 0 0 6.009-0.7359 27.637 27.37 0 0 0 5.5506-2.0405v-23.123zm61.404 63.531-8.0119-0.11275v-15.586l8.6987 0.11276a13.197 13.069 0 0 0 4.4068-0.73586 15.098 14.952 0 0 0 3.9204-2.0405q1.8026-1.3035 3.1762-3.0886a16.939 16.775 0 0 0 2.2315-3.8825 488.2 483.48 0 0 1-5.2365 2.1531 14.323 14.185 0 0 1-4.2591 1.033 13.304 13.175 0 0 1-1.0912 0.0443 28.371 28.097 0 0 1-10.02-1.7433 27.195 26.933 0 0 1-0.62468-0.2404 26.285 26.031 0 0 1-8.728-5.6386 25.735 25.486 0 0 1-5.1838-7.2984 30.191 29.899 0 0 1-0.71025-1.5994q-2.146-5.2428-2.146-11.76v-33.551h15.566v33.551a19.118 18.933 0 0 0 0.18161 2.6696q0.20997 1.4636 0.66574 2.7137a11.687 11.574 0 0 0 0.0974 0.25532 12.981 12.856 0 0 0 1.2505 2.4282 10.651 10.548 0 0 0 1.2962 1.5959 10.187 10.089 0 0 0 3.7481 2.4084q2.146 0.79393 4.6072 0.79393a9.7242 9.6302 0 0 0 4.5498-1.105 12.767 12.643 0 0 0 3.7481-2.9191 14.135 13.998 0 0 0 2.5175-4.1089 12.895 12.77 0 0 0 0.91651-4.7321v-33.551h15.737v53.047a30.818 30.52 0 0 1-2.5175 12.014q-2.4612 5.6108-6.7239 9.8055a32.083 31.773 0 0 1-9.9293 6.631q-5.6655 2.4363-12.133 2.4363zm163.73 0-8.0119-0.11275v-15.586l8.6975 0.11276a13.197 13.069 0 0 0 4.4068-0.73586 15.098 14.952 0 0 0 3.9204-2.0405q1.8026-1.3035 3.1762-3.0886a16.939 16.775 0 0 0 2.2315-3.8825 488.2 483.48 0 0 1-5.2366 2.1531 14.323 14.185 0 0 1-4.2591 1.033 13.304 13.175 0 0 1-1.0912 0.0443 28.371 28.097 0 0 1-10.02-1.7433 27.195 26.933 0 0 1-0.62472-0.2404 26.285 26.031 0 0 1-8.7268-5.6386 25.735 25.486 0 0 1-5.185-7.2984 30.191 29.899 0 0 1-0.71026-1.5994q-2.146-5.2428-2.146-11.76v-33.551h15.567v33.551a19.118 18.933 0 0 0 0.18073 2.6696q0.21085 1.4636 0.66685 2.7137a11.687 11.574 0 0 0 0.0961 0.25532 12.981 12.856 0 0 0 1.2505 2.4282 10.651 10.548 0 0 0 1.2962 1.5959 10.187 10.089 0 0 0 3.7481 2.4084q2.146 0.79393 4.6072 0.79393a9.7242 9.6302 0 0 0 4.5498-1.105 12.767 12.643 0 0 0 3.7481-2.9191 14.135 13.998 0 0 0 2.5187-4.1089 12.895 12.77 0 0 0 0.91535-4.7321v-33.551h15.738v53.047a30.818 30.52 0 0 1-2.5187 12.014q-2.4612 5.6108-6.7238 9.8055a32.083 31.773 0 0 1-9.9293 6.631q-5.6656 2.4363-12.132 2.4363zm-100.66-68.519v45.283h-15.623v-45.283h-7.6111v-15.415h7.6111v-2.8901a26.601 26.344 0 0 1 2.146-10.543 27.075 26.813 0 0 1 5.8941-8.5856q3.7481-3.655 8.7268-5.7802a26.601 26.344 0 0 1 10.644-2.1264h11.732v15.416h-11.732a12.549 12.427 0 0 0-3.3567 0.4343 11.297 11.188 0 0 0-1.3068 0.44456 11.304 11.195 0 0 0-3.72 2.4363 11.684 11.571 0 0 0-2.4893 3.684 11.572 11.461 0 0 0-0.9013 4.0009 13.482 13.351 0 0 0-0.0133 0.61868v2.8901h19.171v15.415zm69.13 45.283h-11.846a26.601 26.344 0 0 1-10.644-2.1252 27.751 27.483 0 0 1-8.7268-5.8382q-3.7493-3.7119-5.8953-8.6425a26.601 26.344 0 0 1-2.146-10.541v-18.022h-7.6111v-15.416h7.6111v-24.256h15.566v24.256h23.692v15.416h-23.692v18.022a11.663 11.55 0 0 0 0.80519 4.2957 11.247 11.138 0 0 0 0.11117 0.26672 11.785 11.671 0 0 0 2.5175 3.7118 12.093 11.976 0 0 0 3.7774 2.5222 11.512 11.4 0 0 0 4.6353 0.93436h11.846zm-166.88-84.842v84.842h-15.737v-84.842z",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: ".29158mm"
});

var SvgGlyftyLogoWithTextExport = function SvgGlyftyLogoWithTextExport(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "516.49mm",
    height: "133.2mm",
    viewBox: "0 0 516.49 133.2",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGlyftyLogoWithTextExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glyfty-logo-with-text-export.fb2da8cc.svg";
export { ForwardRef as ReactComponent };